import SourceGroups from 'collections/sourceGroups'
import fetchOncePromise from 'libraries/fetchOncePromise'

export default fetchOncePromise(new SourceGroups());
